// frontend/src/pages/PricingPage.jsx
import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";



const PricingPage = () => {
  
  return (
    <>
      <WhatsAppButton />
      <Header />
      <section className="section-pricing">
        <div className="pricing-hero">
          <div className="links">
            <h1 className="pricing-heading">Price Plans</h1>
            <Link to="/" className="text-white hover:underline">
              Home
            </Link>
            <span className="text-white"> / Price Plans</span>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold mb-10 inline-block border-b-4 border-blue-600">
          Price Plans
        </h1>
 
        {/* Individual Lessons */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <PricingCard
            title="Driving Lesson"
            description="Automatic / Manual"
            price="45"
            fromText="From"
            hours="Per hour"
            showPerHour={false}
          />
          <PricingCard
            title="Refresher Lesson"
            description="Automatic / Manual"
            price="45"
            fromText="From"
            hours="Per hour"
            showPerHour={false}
          />
          <PricingCard
            title="Weekend & Bank Holiday"
            description="Automatic / Manual"
            price="45"
            fromText="From"
            hours="Per hour"
            showPerHour={true}
          />
        </div>

        {/* Block Booking */}
        <div className="text-center mb-16">
          <h2 className="text-2xl font-semibold mb-4">Block Booking</h2>
          <div className="w-full h-1 bg-blue-600 mb-4"></div>
          <p className="font-semibold">
            Block Booking Discounts – Only available when paid full in advance.
          </p>
        </div>

        {/* Block Booking Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          <PricingCard
            title="10 Hours"
            description="Automatic / Manual"
            price="430"
            fromText="From"
            perHour="43"
          />
          <PricingCard
            title="20 Hours"
            description="Automatic / Manual"
            price="840"
            fromText="From"
            perHour="42"
          />
          <PricingCard
            title="30 Hours"
            description="Automatic / Manual"
            price="1250"
            fromText="From"
            perHour="41.66"
          />
        </div>

        {/* 40 Hours Card - Left Aligned */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          <PricingCard
            title="40 Hours"
            description="Automatic / Manual"
            price="1700"
            fromText="From"
            perHour="42.5"
          />
          {/* Empty divs for remaining grid columns */}
          <div></div>
          <div></div>
        </div>

        {/* Special Courses */}
        <div className="w-full h-1 bg-blue-600 mb-4"></div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <PricingCard
            title="Pass Plus"
            description="Automatic / Manual"
            price="300"
            fromText="From"
            hours="6 hours"
          />
          <PricingCard
            title="Intensive Assessment"
            description="Automatic / Manual"
            price="100"
            fromText="From"
            perHour="50"
            note="2 hrs Intensive Course Assessment"
          />
          <PricingCard
            title="Motorway Driving"
            description="Automatic / Manual"
            price="150"
            fromText="From"
            perHour="50"
          />
        </div>

        <div className="max-w-sm mb-8">
          <PricingCard
            title="Practical Driving Test Car Hire"
            description="Automatic / Manual"
            price="135"
            fromText="From"
            showPerHour={false}
          />
        </div>

        <div className="mt-3 pl-6 space-y-4">
          <li className="text-xl font-semibold">
            Block booking discounts only valid when pay in advance and does not
            include driving test fee neither the hire of car on the test day.
          </li>
          <li className="text-xl font-semibold">
            The hire of the car includes one hour of practice prior to the test,
            one hour for the test, and one hour to get the candidate home. Hire
            of car on test day price does not include extended driving test.
            Hire a car for an extended driving test fee is from{" "}
            <strong>£180.00</strong> for a manual car and
            <strong> £180.00</strong> for an automatic car.
          </li>
          <li className="text-xl font-semibold">
            Pass Plus course contains minimum of 6 hours. Pass Plus certificate
            only applied when minimum of 6 hours have been completed.
          </li>
        </div>
        <div className="mt-8 pl-4 space-y-4">
        <a
          href="/pdf/Drive-with-Portland-Pupil-Terms-and-Conditions.pdf"
           download
           className="bg-[#1D4ED8] text-white px-6 py-2 rounded-full hover:bg-blue-500 transition self-start md:self-auto"
        >
            Download Terms & Conditions
        </a>
        </div>
        <div className="mt-8 pl-4 space-y-4">
        <a
          href="/pdf/Price Plain.pdf"
           download
           className="bg-[#1D4ED8] text-white px-6 py-2 rounded-full hover:bg-blue-500 transition self-start md:self-auto"
        >
            Download Price Plain
        </a>
        </div>
        
      </div>

      <Footer />
    </>
  );
};

const PricingCard = ({
  title,
  description,
  price,
  fromText,
  perHour,
  hours,
  note,
  showPerHour = true,
}) => (
  <div className="bg-gray-200 rounded-md p-8 text-center shadow hover:shadow-xl transition-shadow">
    <h3 className="text-xl font-semibold mb-2">{title}</h3>
    <p className="mb-4">{description}</p>
    <div className="text-4xl font-bold mb-4">
      {fromText && <span className="text-sm font-normal">{fromText} </span>}£
      {price}
      {perHour && showPerHour && (
        <div className="text-sm font-normal">£{perHour} per hour</div>
      )}
      {hours && <div className="text-sm font-normal">{hours}</div>}
    </div>

    <Link
      to="/#contact"
      className="inline-block bg-[#1D4ED8] text-white px-6 py-2 rounded-full hover:bg-blue-500 transition"
    >
      Book Now
    </Link>

    {note && <p className="text-xs mt-3">{note}</p> }
    
  </div>
  
);

export default PricingPage;